import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { tokens, Text } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const Container = styled.div`
  margin: 0 ${tokens.spacer.x2};
  padding: ${tokens.spacer.x1};
  padding-bottom: ${tokens.spacer.x2};
  font-size: 14px;
`;

export const NoMatches = ({ value }: { value: string }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Container>
      <Text textType="subtitle3">
        {t('common:recordings.segment-sidebar.no-matches', { searchValue: value })}
      </Text>
      <br />
      <Text textType="caption">{t('common:recordings.segment-sidebar.no-matches-try')}</Text>
    </Container>
  );
};
